export default "__VITE_ASSET__krdp6eKb__"